import { QuestionCircleIcon } from "./icons";

/** Small "?" circle that shows a one-line explanation on hover, keyboard
 *  focus, or tap. The text is also the accessible label, so screen readers
 *  get it without the popover. Styles live in styles.css (.info-tip). */
export default function InfoTip({ text }: { text: string }) {
  return (
    <span className="info-tip" tabIndex={0} role="img" aria-label={text}>
      <QuestionCircleIcon />
      <span className="info-tip-text" aria-hidden="true">
        {text}
      </span>
    </span>
  );
}
